import { parseErrorObject } from './parse-error-object';
import { parseStatus } from './parse-status';

import type { RequestError } from '../request.d';

export async function handleError(response: Response) {
  const data = await response.json();
  const { detail, message } = parseErrorObject(data);

  const error: RequestError = new Error(message || parseStatus(response.status));

  error.detail = detail;
  error.response = data;
  error.status = response.status;

  throw error;
}
